const es = {
  "header": {
    "badge": "Guía Oficial de BotMix",
    "title": "Administrador de Archivos Multimedia y RAG para IA",
    "summary": "Almacén centralizado de recursos multimedia (imágenes, audios, videos y documentos PDF) para tu empresa. Cada archivo genera una etiqueta única para RAG que puedes incorporar en los prompts de tus Agentes de Inteligencia Artificial para que envíen material oficial automáticamente a tus clientes por WhatsApp."
  },
  "sections": [
    {
      "id": "carga_archivos",
      "title": "1. Carga y Gestión de Archivos",
      "description": "Subida individual de recursos digitales en el servidor.",
      "items": [
        {
          "id": "subida_individual",
          "title": "Archivos Individuales (Máx. 5 MB)",
          "definition": "Sube un archivo por registro (imágenes JPG/PNG/WEBP, audios MP3/OGG/WAV, videos MP4 o documentos PDF/DOC/XLS). El sistema toma el nombre del archivo para identificarlo en la tabla."
        },
        {
          "id": "edicion_reemplazo",
          "title": "Sustitución y Eliminación",
          "definition": "Puedes editar un registro para sustituir el archivo por una versión más actualizada o eliminarlo cuando ya no sea necesario."
        }
      ]
    },
    {
      "id": "etiqueta_rag_ia",
      "title": "2. Etiquetas para RAG e Inteligencia Artificial",
      "description": "Conexión directa entre tus archivos y los Agentes de IA.",
      "items": [
        {
          "id": "etiqueta_copiar",
          "title": "Ruta /files/ (Copiar y Pegar)",
          "definition": "Al hacer clic en cualquier archivo de la tabla, el panel lateral genera su etiqueta oficial (ej: /files/catalogo.pdf). Cópiala con un solo clic."
        },
        {
          "id": "uso_en_prompts",
          "title": "Despacho Automático en Prompts y Flujos",
          "definition": "Pega la etiqueta /files/... dentro del prompt o base de conocimiento de tu Agente de IA en FlowBuilder. Cuando el cliente pregunte por el producto o tema, la IA le enviará el archivo multimedia directamente en el chat."
        }
      ]
    },
    {
      "id": "previsualizacion_metadatos",
      "title": "3. Previsualización y Metadatos",
      "description": "Inspección interactiva de los recursos cargados.",
      "items": [
        {
          "id": "visor_multimedia",
          "title": "Visor y Reproductor Integrado",
          "definition": "El panel lateral permite visualizar imágenes a tamaño real, reproducir audios directamente en el navegador e identificar el icono de documentos PDF, Excel y Word."
        },
        {
          "id": "metadatos_peso",
          "title": "Tipo MIME y Peso en Disco",
          "definition": "Visualiza con exactitud el formato MIME oficial del archivo y el peso que ocupa en KB o MB."
        }
      ]
    },
    {
      "id": "control_almacenamiento",
      "title": "4. Control de Almacenamiento y Cuota",
      "description": "Monitoreo del espacio utilizado en el servidor.",
      "items": [
        {
          "id": "barra_cuota",
          "title": "Barra de Almacenamiento Compacta",
          "definition": "Muestra en tiempo real el espacio ocupado respecto al total asignado a tu plan (porcentaje, gigabytes utilizados y conteo total de archivos)."
        },
        {
          "id": "desglose_categorias",
          "title": "Desglose por Categorías y Cantidad",
          "definition": "Monitorea el peso y número de archivos distribuidos entre Archivos de biblioteca, Envíos Masivos, Flujos, Mensajes, Contactos y Respuestas Rápidas."
        }
      ]
    },
    {
      "id": "depuracion_mensajes",
      "title": "5. Depuración de Multimedia de Mensajes de Chat",
      "description": "Libera almacenamiento masivo eliminando archivos pesados de conversaciones.",
      "items": [
        {
          "id": "filtros_mensajes",
          "title": "Filtros por Antigüedad y Tipo de Archivo",
          "definition": "Filtra mensajes por fecha (> 30, > 60, > 90 días o rangos personalizados) y por formato (audios, videos, imágenes o documentos) para localizar rápidamente los archivos más pesados."
        },
        {
          "id": "borrado_seguro_texto",
          "title": "Eliminación Física Segura con Conservación de Texto",
          "definition": "Al eliminar multimedia de chats, el archivo físico y sus transcodificaciones de audio (.mp3) se borran del disco para recuperar gigabytes inmediatamente, mientras que el texto de la conversación y el registro del ticket se preservan al 100%."
        },
        {
          "id": "depuracion_guiada",
          "title": "Asistente de Depuración Rápida",
          "definition": "Usa el botón 'Depurar Multimedia Antigua' en la cabecera para ejecutar una limpieza guiada en lote según el periodo y tipo de archivo seleccionado."
        }
      ]
    },
    {
      "id": "seleccion_masiva_archivos",
      "title": "6. Selección Múltiple y Eliminación Masiva",
      "description": "Gestión por lotes en la Biblioteca de Archivos.",
      "items": [
        {
          "id": "casillas_seleccion",
          "title": "Casillas de Selección y Seleccionar Todo",
          "definition": "Marca casillas individuales o la casilla maestra en la cabecera para seleccionar múltiples archivos a la vez y eliminarlos en bloque con un solo clic."
        },
        {
          "id": "confirmacion_segura",
          "title": "Modal de Confirmación con Conteo",
          "definition": "El sistema solicita confirmación explícita indicando el número exacto de archivos que serán borrados permanentemente para evitar pérdidas accidentales."
        }
      ]
    },
    {
      "id": "gobernanza_automatizaciones",
      "title": "7. Gobernanza y Protección de Automatizaciones",
      "description": "Blindaje de recursos vinculados a chatbots y respuestas activas.",
      "items": [
        {
          "id": "proteccion_flujos",
          "title": "Protección de FlowBuilder y Respuestas Rápidas",
          "definition": "Los recursos multimedia asociados a Flujos activos y Respuestas Rápidas están protegidos para impedir que los bots queden inoperativos o con enlaces rotos."
        },
        {
          "id": "navegacion_directa",
          "title": "Navegación Asistida a Módulos Oficiales",
          "definition": "Usa los accesos directos desde las pestañas de Flujos, Respuestas Rápidas y Contactos para gestionar y optimizar los recursos directamente en sus editores originales."
        }
      ]
    }
  ]
};

const en = {
  "header": {
    "badge": "BotMix Official Guide",
    "title": "Media File Manager & AI RAG Repository",
    "summary": "Centralized cloud storage for company media assets (images, audio, videos, and PDF documents). Each file generates a unique RAG tag that you can insert into your AI Agent prompts so your bots can automatically send official material to customers on WhatsApp."
  },
  "sections": [
    {
      "id": "carga_archivos",
      "title": "1. File Upload & Management",
      "description": "Individual digital asset storage on the server.",
      "items": [
        {
          "id": "subida_individual",
          "title": "Individual Files (Max 5 MB)",
          "definition": "Upload one asset per entry (JPG/PNG/WEBP images, MP3/OGG/WAV audio, MP4 videos, or PDF/DOC/XLS documents). The system uses the file name for identification in the table."
        },
        {
          "id": "edicion_reemplazo",
          "title": "Replacement & Deletion",
          "definition": "Edit an entry to replace the file with an updated version or delete it when it is no longer required."
        }
      ]
    },
    {
      "id": "etiqueta_rag_ia",
      "title": "2. RAG Tags & AI Integration",
      "description": "Direct connection between stored assets and AI Agents.",
      "items": [
        {
          "id": "etiqueta_copiar",
          "title": "/files/ Route (Copy & Paste)",
          "definition": "Click on any row to display the official tag (e.g. /files/catalog.pdf) in the side drawer. Copy it with a single click."
        },
        {
          "id": "uso_en_prompts",
          "title": "Automated Dispatch in Prompts & Flows",
          "definition": "Paste the /files/... tag inside your AI Agent prompt or FlowBuilder knowledge base. When a client inquires about the topic, the AI will deliver the media directly inside the chat."
        }
      ]
    },
    {
      "id": "previsualizacion_metadatos",
      "title": "3. Preview & File Metadata",
      "description": "Interactive inspection of uploaded resources.",
      "items": [
        {
          "id": "visor_multimedia",
          "title": "Integrated Viewer & Media Player",
          "definition": "The side preview renders high-resolution images, plays audio files directly in the browser, and identifies PDF, Excel, and Word icons."
        },
        {
          "id": "metadatos_peso",
          "title": "MIME Type & Disk Footprint",
          "definition": "Displays the official MIME format and the exact storage footprint in KB or MB."
        }
      ]
    },
    {
      "id": "control_almacenamiento",
      "title": "4. Storage Quota Monitoring",
      "description": "Responsible usage and storage capacity management.",
      "items": [
        {
          "id": "barra_cuota",
          "title": "Compact Storage Bar",
          "definition": "Displays real-time storage consumption relative to your plan's total quota (percentage, used gigabytes, and total file count)."
        },
        {
          "id": "desglose_categorias",
          "title": "Category Breakdown & Counts",
          "definition": "Monitor storage and file counts across Library Files, Bulk Campaigns, Flows, Chat Messages, Contacts, and Quick Replies."
        }
      ]
    },
    {
      "id": "depuracion_mensajes",
      "title": "5. Chat Message Media Cleanup",
      "description": "Free massive disk space by purging heavy chat conversation media.",
      "items": [
        {
          "id": "filtros_mensajes",
          "title": "Filters by Age & File Type",
          "definition": "Filter messages by age (> 30, > 60, > 90 days or custom range) and media type (audio, video, image, doc) to quickly target the heaviest files."
        },
        {
          "id": "borrado_seguro_texto",
          "title": "Safe Physical Purge with Chat Text Preservation",
          "definition": "Purging chat media deletes physical files and iOS transcoded MP3s from disk to recover space immediately, while 100% preserving chat messages and ticket records."
        },
        {
          "id": "depuracion_guiada",
          "title": "Guided Bulk Purge Wizard",
          "definition": "Click 'Purge Old Media' in the top header to run a guided multi-step cleanup based on selected age and media type."
        }
      ]
    },
    {
      "id": "seleccion_masiva_archivos",
      "title": "6. Multi-Select & Batch Deletion",
      "description": "Batch management in the File Library.",
      "items": [
        {
          "id": "casillas_seleccion",
          "title": "Checkboxes & Select All",
          "definition": "Use individual row checkboxes or the master header checkbox to select multiple files and delete them in bulk with one click."
        },
        {
          "id": "confirmacion_segura",
          "title": "Confirmation Dialog with Count",
          "definition": "A security modal displays the exact count of files to be permanently deleted to prevent accidental loss."
        }
      ]
    },
    {
      "id": "gobernanza_automatizaciones",
      "title": "7. Automation Governance & Protection",
      "description": "Protection of active chatbot and automated response assets.",
      "items": [
        {
          "id": "proteccion_flujos",
          "title": "FlowBuilder & Quick Messages Shield",
          "definition": "Assets linked to active Flows and Quick Messages are shielded against accidental deletion to prevent broken bots."
        },
        {
          "id": "navegacion_directa",
          "title": "Direct Module Navigation",
          "definition": "Use direct shortcuts in the Flows, Quick Replies, and Contacts tabs to manage assets inside their native editors."
        }
      ]
    }
  ]
};

const pt = {
  "header": {
    "badge": "Guia Oficial da BotMix",
    "title": "Gerenciador de Arquivos Multimídia e RAG para IA",
    "summary": "Armazenamento centralizado de recursos multimídia (imagens, áudios, vídeos e documentos PDF) para sua empresa. Cada arquivo gera uma tag RAG exclusiva para ser inserida nos prompts dos Agentes de IA, permitindo o envio automático de material oficial no WhatsApp."
  },
  "sections": [
    {
      "id": "carga_archivos",
      "title": "1. Envio e Gestão de Arquivos",
      "description": "Upload individual de recursos digitais no servidor.",
      "items": [
        {
          "id": "subida_individual",
          "title": "Arquivos Individuais (Máx. 5 MB)",
          "definition": "Envie um arquivo por registro (imagens JPG/PNG/WEBP, áudios MP3/OGG/WAV, vídeos MP4 ou documentos PDF/DOC/XLS). O sistema utiliza o nome do arquivo para identificação na tabela."
        },
        {
          "id": "edicion_reemplazo",
          "title": "Substituição e Exclusão",
          "definition": "Edite um registro para substituir o arquivo por uma versão mais recente ou exclua-o quando não for mais necessário."
        }
      ]
    },
    {
      "id": "etiqueta_rag_ia",
      "title": "2. Tags RAG e Inteligência Artificial",
      "description": "Conexão direta entre seus arquivos e os Agentes de IA.",
      "items": [
        {
          "id": "etiqueta_copiar",
          "title": "Caminho /files/ (Copiar e Colar)",
          "definition": "Ao clicar em qualquer arquivo da tabela, o painel lateral gera sua tag oficial (ex: /files/catalogo.pdf). Copie com um único clique."
        },
        {
          "id": "uso_en_prompts",
          "title": "Envio Automático em Prompts e Fluxos",
          "definition": "Cole a tag /files/... no prompt ou base de conhecimento do seu Agente de IA no FlowBuilder. Quando o cliente solicitar informações, a IA enviará o arquivo diretamente na conversa."
        }
      ]
    },
    {
      "id": "previsualizacion_metadatos",
      "title": "3. Pré-visualização e Metadados",
      "description": "Inspeção interativa dos recursos enviados.",
      "items": [
        {
          "id": "visor_multimedia",
          "title": "Visualizador e Player Integrado",
          "definition": "O painel lateral permite visualizar imagens, reproduzir áudios diretamente no navegador e identificar ícones de arquivos PDF, Excel e Word."
        },
        {
          "id": "metadatos_peso",
          "title": "Tipo MIME e Tamanho em Disco",
          "definition": "Mostra o formato MIME oficial e o espaço consumido em disco em KB ou MB."
        }
      ]
    },
    {
      "id": "control_almacenamiento",
      "title": "4. Controle de Armazenamento e Cota",
      "description": "Monitoramento do espaço em disco no servidor.",
      "items": [
        {
          "id": "barra_cuota",
          "title": "Barra de Armazenamento Compacta",
          "definition": "Exibe o espaço consumido em relação à cota total do seu plano (porcentagem, gigabytes e contagem total de arquivos)."
        },
        {
          "id": "desglose_categorias",
          "title": "Detalhamento por Categorias e Contagem",
          "definition": "Monitore o consumo distribuído entre Arquivos, Campanhas em Massa, Fluxos, Mensagens, Contatos e Respostas Rápidas."
        }
      ]
    },
    {
      "id": "depuracion_mensajes",
      "title": "5. Limpeza de Multimídia de Mensagens de Chat",
      "description": "Libere espaço massivo em disco excluindo arquivos pesados de conversas.",
      "items": [
        {
          "id": "filtros_mensajes",
          "title": "Filtros por Antiguidade e Tipo de Arquivo",
          "definition": "Filtre mensagens por data (> 30, > 60, > 90 dias ou intervalos personalizados) e tipo (áudio, vídeo, imagem, documento) para encontrar os arquivos mais pesados."
        },
        {
          "id": "borrado_seguro_texto",
          "title": "Exclusão Física Segura Preservando o Texto",
          "definition": "Ao limpar a mídia das conversas, os arquivos físicos e transcódigos MP3 são excluídos do disco para recuperar espaço imediatamente, mantendo 100% do histórico de texto e tickets."
        },
        {
          "id": "depuracion_guiada",
          "title": "Assistente de Limpeza Guiada",
          "definition": "Use o botão 'Limpar Mídia Antiga' no topo para executar uma limpeza em lote guiada com base no período e tipo selecionados."
        }
      ]
    },
    {
      "id": "seleccion_masiva_archivos",
      "title": "6. Seleção Múltipla e Exclusão em Lote",
      "description": "Gerenciamento em massa na Biblioteca de Arquivos.",
      "items": [
        {
          "id": "casillas_seleccion",
          "title": "Caixas de Seleção e Selecionar Tudo",
          "definition": "Marque caixas individuais ou a caixa mestre no cabeçalho para selecionar vários arquivos simultaneamente e excluí-los em lote com um clique."
        },
        {
          "id": "confirmacion_segura",
          "title": "Confirmação de Segurança com Contagem",
          "definition": "O sistema solicita confirmação explícita indicando a quantidade exata de arquivos que serão excluídos permanentemente."
        }
      ]
    },
    {
      "id": "gobernanza_automatizaciones",
      "title": "7. Governança e Proteção de Automações",
      "description": "Blindagem de recursos vinculados a chatbots e respostas ativas.",
      "items": [
        {
          "id": "proteccion_flujos",
          "title": "Proteção de FlowBuilder e Respostas Rápidas",
          "definition": "Recursos multimídia ligados a Fluxos ativos e Respostas Rápidas são protegidos para evitar que robôs fiquem inoperantes."
        },
        {
          "id": "navegacion_directa",
          "title": "Navegação Direta para Módulos Oficiais",
          "definition": "Utilize atalhos diretos nas abas de Fluxos, Respostas Rápidas e Contatos para editar os recursos em seus ambientes originais."
        }
      ]
    }
  ]
};

const fr = {
  "header": {
    "badge": "Guide Officiel de BotMix",
    "title": "Gestionnaire de Fichiers Multimédia et RAG pour l'IA",
    "summary": "Stockage centralisé des ressources multimédias (images, audios, vidéos et documents PDF) pour votre entreprise. Chaque fichier génère une balise RAG unique à intégrer dans les prompts de vos Agents IA pour envoyer du matériel officiel automatiquement sur WhatsApp."
  },
  "sections": [
    {
      "id": "carga_archivos",
      "title": "1. Téléversement et Gestion des Fichiers",
      "description": "Dépôt individuel de ressources numériques sur le serveur.",
      "items": [
        {
          "id": "subida_individual",
          "title": "Fichiers Individuels (Max. 5 Mo)",
          "definition": "Téléversez un fichier par entrée (images JPG/PNG/WEBP, audios MP3/OGG/WAV, vidéos MP4 ou documents PDF/DOC/XLS). Le système utilise le nom du fichier pour l'identifier dans le tableau."
        },
        {
          "id": "edicion_reemplazo",
          "title": "Remplacement et Suppression",
          "definition": "Modifiez une entrée pour remplacer le fichier par une version plus récente ou supprimez-la lorsqu'elle n'est plus requise."
        }
      ]
    },
    {
      "id": "etiqueta_rag_ia",
      "title": "2. Balises RAG et Intégration IA",
      "description": "Liaison directe entre vos ressources et les Agents IA.",
      "items": [
        {
          "id": "etiqueta_copiar",
          "title": "Chemin /files/ (Copier-Coller)",
          "definition": "Cliquez sur n'importe quel fichier pour afficher sa balise officielle (ex. : /files/catalogue.pdf). Copiez-la d'un simple clic."
        },
        {
          "id": "uso_en_prompts",
          "title": "Envoi Automatique dans les Prompts et Flux",
          "definition": "Collez la balise /files/... dans le prompt de votre Agent IA sur FlowBuilder. Dès qu'un client s'informe, l'IA lui enverra directement le fichier média."
        }
      ]
    },
    {
      "id": "previsualizacion_metadatos",
      "title": "3. Prévisualisation et Métadonnées",
      "description": "Inspection interactive des ressources téléversées.",
      "items": [
        {
          "id": "visor_multimedia",
          "title": "Visionneuse et Lecteur Intégré",
          "definition": "Le panneau latéral permet de visualiser les images haute résolution, d'écouter les audios dans le navigateur et de prévisualiser les documents PDF, Excel et Word."
        },
        {
          "id": "metadatos_peso",
          "title": "Type MIME et Poids sur Disque",
          "definition": "Affiche avec précision le format MIME officiel et l'espace consommé en Ko ou Mo."
        }
      ]
    },
    {
      "id": "control_almacenamiento",
      "title": "4. Contrôle du Stockage et Quotas",
      "description": "Gestion responsable de l'espace alloué.",
      "items": [
        {
          "id": "barra_cuota",
          "title": "Barre de Stockage Compacte",
          "definition": "Affiche en temps réel l'espace consommé par rapport au quota de votre plan (pourcentage, gigaoctets et nombre total de fichiers)."
        },
        {
          "id": "desglose_categorias",
          "title": "Ventilation par Catégories et Nombre",
          "definition": "Consultez l'espace occupé et le nombre de fichiers par Bibliothèque, Campagnes, Flux, Messages, Contacts et Réponses Rapides."
        }
      ]
    },
    {
      "id": "depuracion_mensajes",
      "title": "5. Nettoyage Multimédia des Messages de Chat",
      "description": "Libérez un espace disque massif en purgeant les fichiers lourds des discussions.",
      "items": [
        {
          "id": "filtros_mensajes",
          "title": "Filtres par Ancienneté et Type de Fichier",
          "definition": "Filtrez les messages par ancienneté (> 30, > 60, > 90 jours ou plage personnalisée) et par type de média pour cibler rapidement les fichiers les plus lourds."
        },
        {
          "id": "borrado_seguro_texto",
          "title": "Purge Physique Sécurisée avec Préservation du Texte",
          "definition": "La purge multimédia supprime les fichiers physiques et conversions MP3 du disque pour récupérer de l'espace immédiatement, tout en préservant 100 % du texte des conversations."
        },
        {
          "id": "depuracion_guiada",
          "title": "Assistant de Purge Guidée",
          "definition": "Utilisez le bouton 'Purger Anciens Médias' dans l'en-tête pour exécuter un nettoyage guidé en lot selon la période et le type sélectionnés."
        }
      ]
    },
    {
      "id": "seleccion_masiva_archivos",
      "title": "6. Sélection Multiple et Suppression en Lot",
      "description": "Gestion groupée dans la Bibliothèque de Fichiers.",
      "items": [
        {
          "id": "casillas_seleccion",
          "title": "Cases à Cocher et Tout Sélectionner",
          "definition": "Cochez des cases individuelles ou la case principale de l'en-tête pour sélectionner plusieurs fichiers et les supprimer en bloc en un clic."
        },
        {
          "id": "confirmacion_segura",
          "title": "Modale de Confirmation avec Décompte",
          "definition": "Le système affiche le nombre exact de fichiers qui seront définitivement supprimés afin d'éviter toute perte accidentelle."
        }
      ]
    },
    {
      "id": "gobernanza_automatizaciones",
      "title": "7. Gouvernance et Protection des Automatisations",
      "description": "Blindage des ressources associées aux chatbots actifs.",
      "items": [
        {
          "id": "proteccion_flujos",
          "title": "Protection FlowBuilder et Réponses Rapides",
          "definition": "Les ressources multimédias liées aux Flux actifs et Réponses Rapides sont protégées contre les suppressions accidentelles."
        },
        {
          "id": "navegacion_directa",
          "title": "Navigation Directe vers les Modules Officiels",
          "definition": "Utilisez les boutons d'accès direct dans les onglets Flux, Réponses Rapides et Contacts pour gérer les ressources dans leurs éditeurs d'origine."
        }
      ]
    }
  ]
};

const ar = {
  "header": {
    "badge": "دليل BotMix الرسمي",
    "title": "مدير ملفات الوسائط ومستودع RAG للذكاء الاصطناعي",
    "summary": "مستودع سحابي مركزي لأصول الوسائط للشركة (الصور، الملفات الصوتية، مقاطع الفيديو ومستندات PDF). يقوم كل ملف بإنشاء وسم RAG فريد يمكنك دمجه في موجهات وكلاء الذكاء الاصطناعي لإرسال المواد الرسمية تلقائيًا إلى عملائك عبر واتساب."
  },
  "sections": [
    {
      "id": "carga_archivos",
      "title": "1. رفع وإدارة الملفات",
      "description": "تخزين فردي للأصول الرقمية على الخادم.",
      "items": [
        {
          "id": "subida_individual",
          "title": "ملفات فردية (الحد الأقصى 5 ميجابايت)",
          "definition": "رفع ملف واحد لكل عنصر (صور JPG/PNG/WEBP، تسجيلات صوتية MP3/OGG/WAV، مقاطع MP4 أو مستندات PDF/DOC/XLS). يعتمد النظام على اسم الملف لتعريفه في الجدول."
        },
        {
          "id": "edicion_reemplazo",
          "title": "الاستبدال والحذف",
          "definition": "يمكنك تعديل أي عنصر لاستبدال الملف بنسخة أحدث أو حذفه بالكامل عند انتهاء الحاجة إليه."
        }
      ]
    },
    {
      "id": "etiqueta_rag_ia",
      "title": "2. وسوم RAG والذكاء الاصطناعي",
      "description": "الربط المباشر بين ملفاتك ووكلاء الذكاء الاصطناعي.",
      "items": [
        {
          "id": "etiqueta_copiar",
          "title": "مسار /files/ (نسخ ولصق)",
          "definition": "عند النقر على أي ملف في الجدول، يعرض الشريط الجانبي الوسم الرسمي له (مثل: /files/catalog.pdf). انسخه بنقرة واحدة."
        },
        {
          "id": "uso_en_prompts",
          "title": "الإرسال التلقائي في الموجهات والتدفقات",
          "definition": "الصق الوسم /files/... داخل موجه أو قاعدة معرفة وكيل الذكاء الاصطناعي في FlowBuilder. عندما يسأل العميل عن المنتج، سيقوم الذكاء الاصطناعي بإرسال الملف مباشرة في المحادثة."
        }
      ]
    },
    {
      "id": "previsualizacion_metadatos",
      "title": "3. المعاينة والبيانات الوصفية",
      "description": "فحص تفاعلي للموارد المرفوعة.",
      "items": [
        {
          "id": "visor_multimedia",
          "title": "عارض الصور ومشغل الصوت المدمج",
          "definition": "يتيح الشريط الجانبي معاينة الصور بالحجم الكامل، تشغيل الملفات الصوتية مباشرة داخل المتصفح، وعرض أيقونات ملفات PDF وExcel وWord."
        },
        {
          "id": "metadatos_peso",
          "title": "نوع MIME والحجم على القرص",
          "definition": "يوضح التنسيق الرسمي ونوع MIME والمساحة المستهلكة بدقة بالكيلوبايت أو الميجابايت."
        }
      ]
    },
    {
      "id": "control_almacenamiento",
      "title": "4. مراقبة السعة التخزينية والحصة",
      "description": "إدارة مسؤولة للمساحة المستهلكة على الخادم.",
      "items": [
        {
          "id": "barra_cuota",
          "title": "شريط السعة التخزينية المدمج",
          "definition": "يعرض في الوقت الفعلي المساحة المستهلكة مقارنة بالحصة الإجمالية المخصصة لخطتك (النسبة المئوية والجيجابايت وإجمالي عدد الملفات)."
        },
        {
          "id": "desglose_categorias",
          "title": "التوزيع التفصيلي حسب الفئات والعدد",
          "definition": "متابعة المساحة المستهلكة وعدد الملفات بين المستودع، الرسائل الجماعية، تدفقات الروبوت، الرسائل، جهات الاتصال، والردود السريعة."
        }
      ]
    },
    {
      "id": "depuracion_mensajes",
      "title": "5. تنظيف وسائط رسائل المحادثات",
      "description": "تحرير مساحة تخزين ضخمة عن طريق إزالة الملفات الثقيلة من المحادثات.",
      "items": [
        {
          "id": "filtros_mensajes",
          "title": "التصفية حسب التاريخ ونوع الملف",
          "definition": "تصفية الرسائل حسب القدم (> 30، > 60، > 90 يومًا أو نطاق مخصص) ونوع الوسائط للعثور بسرعة على أثقل الملفات."
        },
        {
          "id": "borrado_seguro_texto",
          "title": "حذف فعلي آمن مع الحفاظ على نصوص المحادثات",
          "definition": "يؤدي تنظيف الوسائط إلى حذف الملفات الفعلية من القرص لاستعادة مساحة فورية، مع الاحتفاظ بنسبة 100% بنصوص المحادثات وسجلات التذاكر."
        },
        {
          "id": "depuracion_guiada",
          "title": "معالج التنظيف الموجه",
          "definition": "انقر فوق زر 'تنظيف الوسائط القديمة' في الأعلى لتنفيذ تنظيف جماعي موجه بناءً على الفترة ونوع الملف المحددين."
        }
      ]
    },
    {
      "id": "seleccion_masiva_archivos",
      "title": "6. التحديد المتعدد والحذف الجماعي",
      "description": "إدارة جماعية في مكتبة الملفات.",
      "items": [
        {
          "id": "casillas_seleccion",
          "title": "مربعات الاختيار وتحديد الكل",
          "definition": "حدد ملفات فردية أو استخدم مربع الاختيار الرئيسي في رأس الجدول لتحديد عدة ملفات وحذفها دفعة واحدة بنقرة واحدة."
        },
        {
          "id": "confirmacion_segura",
          "title": "نافذة تأكيد أمنية مع إظهار العدد",
          "definition": "يعرض النظام رسالة تأكيد توضح العدد الدقيق للملفات التي سيتم حذفها نهائياً لتفادي الحذف الخاطئ."
        }
      ]
    },
    {
      "id": "gobernanza_automatizaciones",
      "title": "7. حماية وأمان الأتمتة والتدفقات",
      "description": "حماية الموارد المرتبطة بروبوتات الدردشة والردود النشطة.",
      "items": [
        {
          "id": "proteccion_flujos",
          "title": "حماية التدفقات والردود السريعة",
          "definition": "الملفات المرتبطة بتدفقات FlowBuilder النشطة والردود السريعة محمية ضد الحذف العرضي لضمان استمرارية عمل الروبوتات دون انقطاع."
        },
        {
          "id": "navegacion_directa",
          "title": "الانتقال المباشر إلى المحررات الأصلية",
          "definition": "استخدم الروابط المباشرة في علامات تبويب التدفقات والردود السريعة وجهات الاتصال لإدارة الموارد داخل محرراتها الأصلية."
        }
      ]
    }
  ]
};

export const FILES_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
